import { createFileRoute, redirect } from '@tanstack/react-router';

import { ensureMediaProjectByIdQueryData } from '@/api/media';

export const Route = createFileRoute(
  '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media/edit/$mediaId/'
)({
  loader: async (props) => {
    try {
      return await ensureMediaProjectByIdQueryData(props);
    } catch {
      throw redirect({
        to: '/projects/$projectId/media',
        params: { projectId: props.params.projectId },
      });
    }
  },
});
